export const STORAGE_TOKEN_KEY = 'Access-Token'
export const STORAGE_LANG_KEY = 'app_lang'
